angular.module('tgaAdmin')
  .controller('HubPrizeAgreementModalController', ['$scope', '$state', '$window', '$uibModalInstance', '$uibModalStack', 'extras',
    function ($scope, $state, $window, $uibModalInstance, $uibModalStack, extras) {
      $scope.data = {
        alerts: [],
      };

      $scope.viewmodel = {
        text: extras.text,
        pages: [],
        current: 0,
      };

      $scope.initialize = function () {
        $scope.viewmodel.pages = $scope.viewmodel.text.match(/<p>(.*?)<\/p>/g);
      };

      $scope.actions = {
        next() {
          $scope.viewmodel.current++;
        },
        back() {
          $scope.viewmodel.current--;
        },
        submit() {
          $uibModalInstance.close();
        },
        close() {
          $uibModalInstance.dismiss();
        },
      };

      $scope.initialize();
    },
  ]);
